import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import withMemo from '../../decorators/WithMemo'
import { pageType, selectors as AppSelectors } from '../../redux/app/redux'
import { selectors as AuthSelectors } from '../../redux/auth/redux'
import routes from '../../routes'
import { iconsKeys } from '../Icon/Icon.assets'

import EventDetails from './index'


function EventDetailsWrapper(props) {
  const { t } = useTranslation()

  const isUserOGCN = useSelector(AuthSelectors.isOGCN)
  const pageSelector = useSelector(AppSelectors.page)
  const eventsLink = pageSelector(pageType.EVENTS).link

  const { event } = props

  const data = {
    ...props,
    event: {
      ...event,
      backLabel: t('eventDetails_backLabel'),
      backLink: eventsLink,
      backRoute: routes.page.name,
      backRouteParams: { slug: eventsLink },
      programLabel: t('eventDetails_programLabel'),
      mapLabel: t('eventDetails_mapLabel'),
      phoneLabel: t('eventDetails_phoneLabel'),
      linkedEventsLabel: t('eventDetails_linkedEventsLabel'),
      indicationLabel: (() => {
        const { cost, secondCost, isFreeForPremium } = event

        let str = ''

        if (cost) {
          str += cost
        }

        if (secondCost) {
          if (str) {
            str += '\n\n'
          }
          str += secondCost
        }
        if (isFreeForPremium) {
          if (str) {
            str += '\n'
          }
          str += t('eventDetails_freeForPremium')
        }
        return str
      })(),
      linkedEvents: event.linkedEvents.map((linkedEvent) => ({
        ...linkedEvent,
        isCurrentOGCN: isUserOGCN,
      })),
    },
    cta: event.link ? {
      label: t('eventDetails_participateLabel'),
      link: event.link,
      isBig: true,
      icon: iconsKeys.ArrowRight,
      iconRight: true,
      target: '_blank',
    } : null,
  }

  return <EventDetails {...data} />
}

EventDetailsWrapper.propTypes = EventDetails.propTypes

export default withMemo()(EventDetailsWrapper)
